import { Select as SelectMaterial } from '@material-ui/core';
import QuestaoSelecaoListImagem from 'components/QuestaoSelecaoListImagem';
import OrcamentoResposta from 'models/OrcamentoResposta';
import Questao from 'models/Questao';
import QuestaoValorSelecao from 'models/QuestaoValorSelecao';
import Select from 'react-select';

import { InputGroup, Input, InputGroupAddon } from 'reactstrap';
import Swal from 'sweetalert2';
import { DropdownTipoQuestao } from 'views/pages/css';
import ImagemMultiSelecao from './ImagemMultiSelecao';

interface ValorAssociacao {
  questaoValorSelecaoId: number;
  descricao: string;
  valoresDependencia: {
    id: number;
    questaoId: number;
    descricao: string;
  }[];
}

interface Props {
  questao: Questao;
  questoes: Questao[] | undefined;
  respostas: OrcamentoResposta[];
  valoresAssociacao: ValorAssociacao[];
  setaNovaRespostaQuestao: (
    questao: Questao,
    novoValor: string,
    questoesRelacionadasToSetEmpty?: Questao[],
  ) => void;
  setaNovaRespostaImagem: (novoValor: string) => void;
  setaIdImagem: (idImagem: number) => void;
}

function QuestaoInput({
  questao,
  questoes,
  respostas,
  valoresAssociacao,
  setaNovaRespostaQuestao,
  setaNovaRespostaImagem,
  setaIdImagem,
}: Props): JSX.Element {
  if (!questao) {
    return <></>;
  }

  const { tipo, unidadeMedida, valorMinimo, valorMaximo } = questao;

  if (tipo === 'TI') return <></>;

  const respostaQuestao = respostas.find(
    (resposta: OrcamentoResposta) => resposta.questaoId === questao.id,
  );

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const novoValor = event.target.value;
    setaNovaRespostaQuestao(questao, novoValor);
  }

  function handleSelectChangeImage(novoValor: string | undefined) {
    setaNovaRespostaQuestao(questao, novoValor ?? '');
  }

  function handleSelectChangeImageValue(novoValor: string | undefined) {
    setaNovaRespostaImagem(novoValor ?? '');
  }

  function handleSetIdImage(idImagem: number) {
    setaIdImagem(idImagem);
  }

  // para tipos Texto ou Number cria componente <Input />
  if (['T', 'N'].includes(tipo)) {
    const isNumberInput = tipo === 'N';

    return (
      <InputGroup className="input-group-alternative invalid-feedback">
        <Input
          required={questao.isObrigatorio ?? false}
          disabled={questao.bloquear ?? false}
          type={isNumberInput ? 'number' : 'text'}
          min={valorMinimo ?? undefined}
          max={valorMaximo ?? undefined}
          step={0.01}
          value={respostaQuestao?.resposta || ''}
          onChange={handleInputChange}
        />
        <InputGroupAddon addonType="append">{unidadeMedida}</InputGroupAddon>
      </InputGroup>
    );
  }

  // Seleção ou Imagem
  if (['S', 'IM'].includes(tipo)) {
    const questaoValoresSelecao =
      questao.QuestaoValorSelecao as QuestaoValorSelecao[];

    const questaoValoresFiltradosSelecao = questaoValoresSelecao.filter(
      valorSelecao => {
        let exibeAlternativa = true;

        const relacao = valoresAssociacao.find(
          v => v.questaoValorSelecaoId === valorSelecao.id,
        );

        if (relacao) {
          exibeAlternativa = false;
          const valoresDependencia = relacao?.valoresDependencia;

          const validarRespostas = valoresDependencia?.map(valorDependencia => {
            const respostaValida = respostas.find(
              resposta =>
                resposta.questaoId === valorDependencia.questaoId &&
                String(resposta.resposta).toUpperCase() ===
                  String(valorDependencia.descricao).toUpperCase(),
            );

            return {
              respostaValida: !!respostaValida,
              ...valorDependencia,
            };
          });

          // const agrupado = validarRespostas.reduce(
          //   (resultado: any, objeto: any) => {
          //     if (!resultado[objeto.questaoId]) {
          //       resultado[objeto.questaoId] = [];
          //     }
          //     resultado[objeto.questaoId].push(objeto);
          //     return resultado;
          //   },
          //   {},
          // );

          const agrupado = validarRespostas.reduce((acc: any, objeto: any) => {
            const key = objeto.questaoId;
            return {
              ...acc,
              [key]: [...(acc[key] || []), objeto],
            };
          }, {} as Record<string, any[]>);

          const arraysAgrupados = Object.values(agrupado);

          exibeAlternativa = arraysAgrupados?.every((valorDependencia: any) => {
            return (
              valorDependencia.filter(
                (valor: any) => valor.respostaValida === true,
              ).length > 0
            );
          });
        }

        return exibeAlternativa;
      },
    );

    const questoesRelacionadas = questoes?.filter(
      thisQuestao =>
        thisQuestao.questaoSelecaoAssociada?.questaoId === questao.id,
    );

    // para tipos Imagem
    if (tipo === 'IM') {
      const respostaAtual = respostaQuestao?.resposta;

      // só usa o default se a questão NÃO existir no array respostas (nunca foi tocada)
      const itemSelecionado = questaoValoresFiltradosSelecao.find(
        x =>
          String(x.descricao).toUpperCase() ===
            String(respostaAtual).toUpperCase() ||
          (!respostaQuestao && x.isDefault === true),
      );

      const descricaoSelecao = itemSelecionado?.descricao ?? '';

      if (
        descricaoSelecao &&
        descricaoSelecao !== respostaAtual &&
        !respostaQuestao
      ) {
        setTimeout(() => {
          setaNovaRespostaQuestao(
            questao,
            descricaoSelecao,
            questoesRelacionadas,
          );
        }, 0);
      }

      const isVazia = !respostaAtual || respostaAtual === '';

      if (questao.permiteMultiSelecao) {
        const respostasSplit = String(respostaAtual || '')
          .toUpperCase()
          .split(',')
          .filter(x => x !== '');

        return (
          <ImagemMultiSelecao
            key={`multi-img-${questao.id}-${isVazia ? 'limpa' : 'ativa'}`}
            valoresSelecao={questaoValoresFiltradosSelecao}
            listaValoresSelecao={questaoValoresSelecao}
            visaoEmLinhaDefault
            readOnly
            handleChangeValorQuestionario={handleSelectChangeImage}
            respostaImagemSelecionada={questaoValoresFiltradosSelecao.filter(
              x => respostasSplit.includes(String(x.descricao).toUpperCase()),
            )}
            requiredImage={questao.isObrigatorio ?? false}
            handleChangeImageValue={handleSelectChangeImageValue}
            handleSetaIdImage={handleSetIdImage}
          />
        );
      }

      return (
        <QuestaoSelecaoListImagem
          key={`single-img-${questao.id}-${isVazia ? 'limpa' : 'ativa'}`}
          valoresSelecao={questaoValoresFiltradosSelecao}
          listaValoresSelecao={questaoValoresSelecao}
          visaoEmLinhaDefault
          readOnly
          handleChangeValorQuestionario={handleSelectChangeImage}
          respostaImagemSelecionada={itemSelecionado}
          requiredImage={questao.isObrigatorio ?? false}
          handleChangeImageValue={handleSelectChangeImageValue}
          handleSetaIdImage={handleSetIdImage}
        />
      );
    }

    // para tipos Seleção normal (Dropdown)
    const respostaAtual = respostaQuestao?.resposta;

    const itemSelecionadoSelect = questaoValoresFiltradosSelecao.find(
      item =>
        String(item.descricao).toUpperCase() ===
          String(respostaAtual).toUpperCase() ||
        (!respostaQuestao && item.isDefault === true && !questao.isObrigatorio),
    );

    const descricaoSelecaoSelect =
      itemSelecionadoSelect?.descricao ?? 'Selecione';

    if (!respostaQuestao && descricaoSelecaoSelect !== 'Selecione') {
      setTimeout(() => {
        setaNovaRespostaQuestao(
          questao,
          descricaoSelecaoSelect,
          questoesRelacionadas,
        );
      }, 0);
    }

    if (questao.permiteMultiSelecao) {
      const opcoes = questaoValoresFiltradosSelecao.map((item: any) => {
        return { label: item.descricao, value: item.descricao };
      });

      const arrayRespostas =
        respostaAtual?.split(',').filter(x => x !== '') ?? [];
      const valores = opcoes.filter(objeto =>
        arrayRespostas.includes(objeto.value),
      );

      return (
        <InputGroup className="input-group-alternative">
          <DropdownTipoQuestao
            style={{ minWidth: unidadeMedida ? '65%' : '100%' }}
          >
            <div style={{ width: '100%' }}>
              <Select
                closeMenuOnSelect={false}
                placeholder="Selecione"
                isMulti
                required={questao.isObrigatorio ?? false}
                value={valores}
                options={opcoes}
                onChange={(e: any) => {
                  const resposta = e.map((it: any) => it.value)?.join(',');
                  setaNovaRespostaQuestao(
                    questao,
                    resposta,
                    questoesRelacionadas,
                  );
                }}
              />
            </div>
          </DropdownTipoQuestao>
          <InputGroupAddon addonType="append">{unidadeMedida}</InputGroupAddon>
        </InputGroup>
      );
    }

    return (
      <InputGroup className="input-group-alternative">
        <DropdownTipoQuestao
          style={{ minWidth: unidadeMedida ? '65%' : '100%' }}
        >
          <SelectMaterial
            style={{ minWidth: unidadeMedida ? '65%' : '100%' }}
            className="dropdown-menu-arrow"
            required={questao.isObrigatorio ?? false}
            disabled={questao.bloquear ?? false}
            value={
              descricaoSelecaoSelect === 'Selecione'
                ? ''
                : descricaoSelecaoSelect
            }
            multiple={questao.permiteMultiSelecao ?? false}
            onChange={event => {
              setaNovaRespostaQuestao(
                questao,
                String(event.target.value),
                questoesRelacionadas,
              );
            }}
          >
            <option className="dropdown-item" key={null} value="">
              Selecione...
            </option>
            {questaoValoresFiltradosSelecao.map(item => {
              return (
                <option
                  className="dropdown-item"
                  key={item.id}
                  value={item.descricao}
                >
                  {item.descricao}
                </option>
              );
            })}
          </SelectMaterial>
        </DropdownTipoQuestao>
        <InputGroupAddon addonType="append">{unidadeMedida}</InputGroupAddon>
      </InputGroup>
    );
  }

  return <></>;
}

export default QuestaoInput;
